import * as React from 'react';

export function usePrevious(value) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
